import React from 'react'

import {
  Box,
  Tab as ChakraTab,
  TabList as ChakraTabList,
  TabPanel as ChakraTabPanel,
  TabPanels as ChakraTabPanels,
  Tabs as ChakraTabs,
  Text,
  Flex,
} from '@chakra-ui/react'
import { Route, Routes, Link } from 'react-router'
import { Select, SelectItem } from 'src/components/Select/Select'
import { usePermission, useSelectedTrial } from 'src/features/auth/context'
import { PERMISSIONS } from 'src/lib/permission'

import { AddIcfDocumentContainer } from './icf-document/add/add-container'
import { AddIcfDocumentRevisionContainer } from './icf-document/add-revision/add-revision-container'
import { EditIcfDocumentContainer } from './icf-document/edit/edit-container'
import { IcfDocumentListContainer } from './icf-document/list/list-container'
import { AddIcfDocumentSetContainer } from './icf-document-set/add/add-container'
import { IcfDocumentSetDetailContainer } from './icf-document-set/detail/detail-container'
import { EditIcfDocumentSetContainer } from './icf-document-set/edit/edit-container'
import { IcfDocumentSetListContainer } from './icf-document-set/list/list-container'
import { getIcfDocumentListRoute, getIcfDocumentSetListRoute } from './routes'
import { useIcfDocumentHospital } from './use-icf-document-hospital'
import { getRelativePath } from '../../../../../../constants/paths'

export const IcfDocument: React.FC = () => {
  return (
    <Routes>
      <Route
        path={`${getRelativePath('IcfDocuments', 'IcfDocuments')}/*`}
        element={
          <Routes>
            <Route
              path={``}
              element={<ListComponentRenewal selectedNode="documents" />}
            />
            <Route
              path={getRelativePath('IcfDocuments', 'IcfDocumentsNew')}
              element={<AddIcfDocumentContainer />}
            />
            <Route
              path={getRelativePath('IcfDocuments', 'IcfDocumentAddRevision')}
              element={<AddIcfDocumentRevisionContainer />}
            />
            <Route
              path={getRelativePath('IcfDocuments', 'IcfDocumentEdit')}
              element={<EditIcfDocumentContainer />}
            />
          </Routes>
        }
      />
      <Route
        path={`${getRelativePath('IcfDocuments', 'IcfDocumentSets')}/*`}
        element={
          <Routes>
            <Route
              path={``}
              element={<ListComponentRenewal selectedNode="sets" />}
            />
            <Route
              path={getRelativePath('IcfDocumentSets', 'IcfDocumentSetNew')}
              element={<AddIcfDocumentSetContainer />}
            />
            <Route
              path={getRelativePath('IcfDocumentSets', 'IcfDocumentSet')}
              element={<IcfDocumentSetDetailContainer />}
            />
            <Route
              path={getRelativePath('IcfDocumentSets', 'IcfDocumentSetEdit')}
              element={<EditIcfDocumentSetContainer />}
            />
          </Routes>
        }
      />
    </Routes>
  )
}

const ListComponentRenewal: React.FC<{
  selectedNode: 'documents' | 'sets'
}> = ({ selectedNode }) => {
  const { hasPermission } = usePermission()

  const shouldSelectHospital = hasPermission(PERMISSIONS.Hospital_BelongAll)

  const { selectedTrial } = useSelectedTrial()
  const { uid: trialUid, trialHospitals } = selectedTrial

  const selectItem: SelectItem[] = trialHospitals.map(trialHospital => ({
    value: trialHospital.uid,
    label: trialHospital.name,
  }))

  const { selectedTrialHospitalUid, onChangeTrialHospital } =
    useIcfDocumentHospital()

  const tabIndex = selectedNode === 'sets' ? 1 : 0

  return (
    <Box h="full" p="6">
      <ChakraTabs
        index={tabIndex}
        h="full"
        display="flex"
        flexDirection="column"
      >
        <Flex justify="space-between" wrap="wrap" columnGap="8" rowGap="1">
          {/* h=tabの高さ+borderの1pxと合わせることで中央揃えの見た目にする */}
          <Flex h="calc(2.125rem + 1px)" mb="4" align="center">
            <Text as="h1" fontSize="lg" fontWeight="bold">
              文書管理
            </Text>
          </Flex>
          <ChakraTabList mb="4" flex="1">
            <ChakraTab
              as={Link}
              to={getIcfDocumentListRoute({
                trialUid,
                trialHospitalUid: shouldSelectHospital
                  ? selectedTrialHospitalUid
                  : undefined,
              })}
            >
              文書一覧
            </ChakraTab>
            <ChakraTab
              as={Link}
              to={getIcfDocumentSetListRoute({
                trialUid,
                trialHospitalUid: shouldSelectHospital
                  ? selectedTrialHospitalUid
                  : undefined,
              })}
            >
              文書セット一覧
            </ChakraTab>
          </ChakraTabList>
          {shouldSelectHospital && (
            <Select
              onChange={onChangeTrialHospital}
              value={selectedTrialHospitalUid}
              items={selectItem}
              placeholder="医療機関を選択してください"
              width="320px"
            />
          )}
        </Flex>

        <ChakraTabPanels flex="1" overflow="auto">
          <ChakraTabPanel h="full" p="0">
            <IcfDocumentListContainer />
          </ChakraTabPanel>
          <ChakraTabPanel h="full" p="0">
            <IcfDocumentSetListContainer />
          </ChakraTabPanel>
        </ChakraTabPanels>
      </ChakraTabs>
    </Box>
  )
}
